export const monthlyCostDefaultLocalizationParameters = {
    amortizationDebtToIncomeFactor: 4.5,
    highLoanToValueThreshold: 0.7,
    lowLoanToValueThreshold: 0.5,
    highAmortizationRate: 0.02,
    lowAmortizationRate: 0.01,
    incomeBasedAmortizationRate: 0.01,
    interestDeductionThreshold: 100000,
    baseInterestDeductionRate: 0.3,
    extraInterestDeductionRate: 0.21,
};
